import { render, staticRenderFns } from "./TrustAuthority.vue?vue&type=template&id=00ebca5e&scoped=true"
import script from "./TrustAuthority.vue?vue&type=script&lang=js"
export * from "./TrustAuthority.vue?vue&type=script&lang=js"
import style0 from "./TrustAuthority.vue?vue&type=style&index=0&id=00ebca5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ebca5e",
  null
  
)

export default component.exports